<template>
	<button type="button" class="provider" :class="{ selected }" :aria-pressed="selected" @click="emit('toggle')">
		<span class="header">
			<span class="name"><span class="marker" />{{ provider.label }}</span>
			<AppIcon v-if="selected" :name="IconName.Check" :size="14" />
		</span>
		<span class="description">{{ description }}</span>
	</button>
</template>

<script setup lang="ts">
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"
import type { ContactResearchProviderInfo } from "@/types/contactResearch"

defineProps<{
	provider: ContactResearchProviderInfo
	selected: boolean
	description: string
}>()

const emit = defineEmits<{
	toggle: []
}>()
</script>

<style scoped>
.provider {
	display: grid;
	gap: var(--space-6);
	padding: var(--space-12) var(--space-14);
	font: inherit;
	color: var(--neutral-900);
	text-align: left;
	background: var(--neutral-0);
	border: var(--border-width-thin) solid var(--neutral-200);
	border-radius: var(--border-radius-base);
	cursor: pointer;

	&.selected {
		background: color-mix(in srgb, var(--primary-green) 7%, white);
		border-color: var(--primary-green);
	}

	&:focus-visible {
		outline: 2px solid var(--primary-green);
		outline-offset: 2px;
	}
}

.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--space-12);

	> svg {
		color: var(--primary-green);
	}
}

.name {
	display: inline-flex;
	align-items: center;
	gap: var(--space-8);
	font-size: var(--font-size-small);
	font-weight: var(--font-weight-medium);
}

.marker {
	width: var(--space-8);
	height: var(--space-8);
	background: var(--neutral-400);
	border-radius: var(--border-radius-sm);

	.selected & {
		background: var(--primary-green);
	}
}

.description {
	color: var(--neutral-600);
	font-size: var(--font-size-xs);
	line-height: var(--line-height-relaxed);
}
</style>
